import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SEO, PATH_NAMES } from '../../shared/constants';
import { SeoModel } from '../../shared/models/seo.model';

@Injectable({
  providedIn: 'root',
})
export class SeoService {
  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    @Inject(DOCUMENT) private readonly document: any,
    private readonly title: Title,
    private readonly meta: Meta
  ) {}

  updateSeoByPath(path: string): void {
    const seoMap: Record<string, any> = {
      [PATH_NAMES.FLIGHTS]: SEO.flights,
      [PATH_NAMES.HOTELS]: SEO.hotels,
      [PATH_NAMES.FLIGHT_HOTEL]: SEO.flightAndHotel,
      [PATH_NAMES.PACKAGES]: SEO.touristPackages,
      [PATH_NAMES.TRAVEL_INSURANCE]: SEO.travelInsurance,
      [PATH_NAMES.POLICIES]: SEO.policies,
      [PATH_NAMES.BOOKING]: SEO.booking,
      [PATH_NAMES.RESPONSIBILITY]: SEO.responsability,
      [PATH_NAMES.DATE]: SEO.date,
      [PATH_NAMES.COMPLAINTS]: SEO.complaints,
      [PATH_NAMES.BENEFITS]: SEO.benefits,
      [PATH_NAMES.JULY]: SEO.july,
      [PATH_NAMES.COMPANY]: SEO.company,
      [PATH_NAMES.DOCUMENT_TRAVEL]: SEO.documentTravel,
      [PATH_NAMES.TERM_COND]: SEO.termCond,
      [PATH_NAMES.PROMOTION]: SEO.promotions,
      [PATH_NAMES.SUSCRIPTION]: SEO.subscriptions,
      [PATH_NAMES.EVENTS]: SEO.events,
      [PATH_NAMES.RECEPTION]: SEO.reception,
      [PATH_NAMES.TRAVEL_OUT]: SEO.traveloutlet,
      [PATH_NAMES.CANALES]: SEO.canales,
      [PATH_NAMES.AGENCIES]: SEO.agencies,
    };

    this.updatePageMetaTags(seoMap[path] ?? SEO.home);
  }

  updatePageMetaTags(seoDetails: SeoModel) {
    this.title.setTitle(seoDetails.title);

    const fullPageUrl = seoDetails.url;
    const metaTagData = {
      title: seoDetails.title,
      description: seoDetails.description,
      'og:title': seoDetails.title,
      'og:description': seoDetails.description,
      'og:image': seoDetails.image,
      'og:image:height': seoDetails.height,
      'og:image:width': seoDetails.width,
      'og:url': fullPageUrl,
      canonical: fullPageUrl,
    };

    Object.entries(metaTagData).forEach(([metaName, metaContent]) =>
      this.meta.updateTag({ name: metaName, content: metaContent ?? '' })
    );

    this.updateLinkTagByRel('canonical', fullPageUrl);
    this.updateLinkTagByRel('alternate', fullPageUrl);
  }

  private updateLinkTagByRel(rel: string, url: string) {
    if (!isPlatformBrowser(this.platformId)) return;

    let linkElement: HTMLLinkElement | null = this.document.querySelector(`link[rel='${rel}']`);

    if (!linkElement) {
      linkElement = this.document.createElement('link');
      linkElement?.setAttribute('rel', rel);
      this.document.head.appendChild(linkElement);
    }

    linkElement?.setAttribute('href', url);
  }
}
